import http from 'hub-http/clients/apiClient';
export const fetchPreferences = () => {
  return http.get('notification/preferences/v1/preferences');
};